import { Box, Button, TextField, Typography } from "@mui/material";
import axios from "axios";
import Cookies from "js-cookie";
import React, { useState } from "react";
import SimpleBackdrop from "./BackDrop";
import ChangeUpdateEmail from "./ChangeUpdateEmail";
import "./settings-modern.css";

function ChangeEmail() {
  const [sentOtp, setSentOtp] = useState("");
  const [otp, setValue] = useState("");
  const [err, setErr] = useState("");
  const [next1, setNext1] = useState(false);
  const [next, setNext] = useState(false);
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");

  const handleSubmit = () => {
    if (otp.toString() === sentOtp.toString()) setNext1(true);
  };

  const sentEmail = () => {
    setOpen(true);
    setErr("");
    axios.post(
      `${process.env.React_APP_BACKEND_URL}/api/forgot`,
      { email },
      { headers: { Authorization: `Bearer ${Cookies.get("token")}` } }
    ).then((res) => {
      setOpen(false);
      setSentOtp(res.data.otp);
      setNext(true);
    }).catch((error) => {
      setOpen(false);
      setErr("לא נמצאה כתובת הדוא\"ל הזו בחשבון.");
      console.log(error);
    });
  };

  if (next1) return <ChangeUpdateEmail />;

  return (
    <Box className="bidit-settings-page-card">
      {!next ? (
        <>
          <Box className="bidit-settings-head">
            <Typography className="bidit-settings-title">עדכון כתובת דוא"ל</Typography>
            <Typography className="bidit-settings-subtitle">כדי לשמור על החשבון מאובטח, נאמת קודם את כתובת הדוא"ל הנוכחית.</Typography>
          </Box>
          <Typography className="bidit-settings-field-label">כתובת הדוא"ל הנוכחית</Typography>
          <TextField
            required
            fullWidth
            id="email"
            value={email}
            onChange={(e) => setEmail(e.currentTarget.value)}
            name="email"
            autoComplete="email"
            placeholder="name@example.com"
          />
          {err && <Box className="bidit-settings-error">{err}</Box>}
          <Button fullWidth variant="contained" className="bidit-settings-primary" onClick={sentEmail} sx={{ mt: 2.5 }}>
            שליחת קוד אימות
          </Button>
        </>
      ) : (
        <>
          <Box className="bidit-settings-head">
            <Typography className="bidit-settings-title">אימות כתובת הדוא"ל</Typography>
            <Typography className="bidit-settings-subtitle">הזינו את הקוד בן 6 הספרות שנשלח אליכם.</Typography>
          </Box>
          <Box dir="ltr" sx={{ my: 2, textAlign: "center" }}>
            <input
              className="auth-modern-one-time-code"
              type="text"
              value={otp}
              onChange={(e) => setValue(e.target.value.replace(/\D/g, "").slice(0, 6))}
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={6}
              autoComplete="one-time-code"
              name="one-time-code"
              aria-label="קוד אימות בן 6 ספרות"
              autoFocus
            />
          </Box>
          <Button fullWidth variant="contained" className="bidit-settings-primary" onClick={handleSubmit} disabled={otp.length !== 6}>
            המשך לעדכון הדוא"ל
          </Button>
        </>
      )}
      {open && <SimpleBackdrop open={open} setOpen={setOpen} handleClose={() => setOpen(false)} handleToogle={() => setOpen(!open)} />}
    </Box>
  );
}

export default ChangeEmail;
